import React from 'react';
import ReactDOM from 'react-dom';
import GhostInput from './GhostInput';

ReactDOM.render(
  <GhostInput />,
  document.getElementById('container-ghost-input')
);



// WEBPACK FOOTER //
// ./src/index.js